import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums } from "../lib";

/**
 * Check if user can add groups based on org settings
 * Rules:
 * 1. For dilwariGroup org only:
 *    - If settings value is "true": only admins can add groups
 *    - If settings value is "false": admins & others can add groups
 *    - If no settings value: anybody can add groups (default false)
 * 2. For all other orgs: anybody can add groups (always return true)
 */
export default () => {
    const { auth, userOrganisations, typesList } = useSelector(
        (state) => state
    );
    const currentOrgId = userOrganisations?.item?.id;
    const isDilwariGroup = enums.organisationIds.dilwariGroup === currentOrgId;

    const isAdmin = useMemo(() => {
        if (auth && auth.adminGroups && auth.adminGroups.length) {
            return auth.adminGroups.some(
                ({ id }) => id === enums.auth.group.admin
            );
        }
        return false;
    }, [auth]);

    const allowOnlyAdminsToCreateGroup = useMemo(() => {
        // If not dilwari org, always return false (anybody can add groups)
        if (!isDilwariGroup) {
            return false;
        }

        /** id for auto select all auditor */
        const allowAdminsToCreateGroupAudit = 8;
        const { organisationSettings } = typesList;
        const { data } = organisationSettings;

        if (data && data.length > 0) {
            const setting = data.find(
                (item) => item.settingId === allowAdminsToCreateGroupAudit
            );

            if (setting && setting.value) {
                // Boolean("false") returns true, so we need explicit check
                return setting.value.toLowerCase() === "true";
            }
        }

        // No setting found - default to false (anybody can add groups)
        return false;
    }, [typesList, isDilwariGroup]);

    // For DilwariGroup org: allow group creation based on admin status and settings
    // For other orgs: always allow (return true)
    if (isDilwariGroup) {
        // If setting is true: only admins can add groups
        // If setting is false: anybody can add groups
        return allowOnlyAdminsToCreateGroup ? isAdmin : true;
    }

    // Non-dilwari orgs: anybody can add groups
    return true;
};
